export const TYPE_STANDARD = 'standard'
export const TYPE_ENHANCED = 'enhanced'

export const USE_CASE_CATEGORIES = [
    {value: '2FA', label: '2FA'},
    {value: 'ACCOUNT_NOTIFICATION', label: 'Account Notification'},
    {value: 'AGENTS_FRANCHISES', label: 'Agents & Franchises'},
    {value: 'CARRIER_EXEMPT', label: 'Carrier Exempt'},
    {value: 'CHARITY', label: 'Charity'},
    {value: 'CUSTOMER_CARE', label: 'Customer Care'},
    {value: 'DELIVERY_NOTIFICATION', label: 'Delivery Notification'},
    {value: 'EMERGENCY', label: 'Emergency'},
    {value: 'FRAUD_ALERT', label: 'Fraud Alert'},
    {value: 'HIGHER_EDUCATION', label: 'Higher Education'},
    {value: 'K12_EDUCATION', label: 'K-12 Education'},
    {value: 'LOW_VOLUME', label: 'Low Volume'},
    {value: 'MARKETING', label: 'Marketing'},
    {value: 'MIXED', label: 'Mixed'},
    {value: 'POLITICAL', label: 'Political'},
    {value: 'POLLING_VOTING', label: 'Polling & Voting'},
    {value: 'PROXY', label: 'Proxy'},
    {value: 'PUBLIC_SERVICE_ANNOUNCEMENT', label: 'Public Service Announcement'},
    {value: 'SECURITY_ALERT', label: 'Security Alert'},
    {value: 'SOCIAL', label: 'Social'},
    {value: 'SOLE_PROPRIETOR', label: 'Sole Proprietor'},
    {value: 'SWEEPSTAKE', label: 'Sweepstake'},
]
